<app-nav [navItems]="navItems" />
<div class="static">
  <h1>Terms of use</h1>
  <p>
    Welcome to ImageBase.pro. By accessing or using our website, you agree to
    the following Terms of Use. Please read them carefully, as they govern your
    rights and responsibilities when using our platform. If you do not agree
    with these terms, please refrain from using the site.
  </p>
  <p>
    <strong>1. General Provisions</strong>
  </p>
  <p><strong>1.1. Ownership and Management</strong></p>
  <p>
    The content provided on <strong>ImageBase.pro</strong> is owned by
    <strong>V V G LLC</strong> and is distributed and sold under an agreement
    with <strong>DIGITAL DP LTD</strong>.
  </p>
  <p>
    <strong>DIGITAL DP LTD</strong> acts as the official and authorized
    distributor of the content and is responsible for customer relations,
    including sales, support, and payment processing. Intellectual property
    rights remain with <strong>V V G LLC</strong>.
  </p>
  <p>
    <strong>1.2. Official Status of DIGITAL DP LTD</strong>
  </p>
  <p>
    <strong>DIGITAL DP LTD</strong> is the sole seller and customer contact
    point for ImageBase.pro. It ensures compliance with all customer-related
    obligations under its agreement with <strong>V V G LLC</strong>.
  </p>
  <p><strong>1.3. Changes to Terms</strong></p>
  <p>
    We reserve the right to update or modify these terms at any time without
    prior notice. By continuing to use the platform after changes are made, you
    agree to the updated terms.
  </p>
  <p><strong>2. Platform Use</strong></p>
  <p><strong>2.1. Eligibility</strong></p>
  <p>To use ImageBase.pro, you must:</p>
  <ul>
    <li>Be at least 18 years old or have the consent of a legal guardian.</li>
    <li>Comply with all applicable laws and regulations.</li>
  </ul>

  <p><strong>2.2. Account Registration</strong></p>
  <p>
    Certain features of the platform require account registration. By
    registering, you agree to:
  </p>
  <ul>
    <li>Provide accurate and up-to-date information.</li>
    <li>Keep your login credentials secure.</li>
    <li>
      Notify us immediately if you suspect unauthorized access to your account.
    </li>
  </ul>
  <p><strong>2.3. Permitted Use</strong></p>
  <p>
    You are granted a non-exclusive, limited, and revocable license to use the
    platform for personal or commercial purposes in accordance with our
    <a routerLink="/licensing-policy">Licensing Policy</a>.
  </p>
  <p><strong>2.4. Prohibited Activities</strong></p>
  <p>You may not:</p>
  <ul>
    <li>Use the platform for unlawful purposes.</li>
    <li>
      Attempt to hack, decompile, or modify the site’s software or content.
    </li>
    <li>
      Resell, redistribute, or sublicense content without proper licensing.
    </li>
    <li>Use automated systems (e.g., bots) to download or scrape content.</li>
  </ul>
  @if (false) {
    <p><strong>4. Payments and Subscriptions</strong></p>
  } @else {
    <p><strong>4. Payments</strong></p>
  }
  <p><strong>4.1. Payments</strong></p>
  @if (false) {
    <p>
      All payments on the platform are processed by
      <strong>DIGITAL DP LTD</strong>. Customers must pay for premium images or
      subscriptions through accepted payment methods (e.g., credit cards,
      PayPal). Payments are non-refundable unless otherwise specified in our
      <a routerLink="/refund-policy">Refund Policy</a>.
    </p>
  } @else {
    <p>
      All payments on the platform are processed by
      <strong>DIGITAL DP LTD</strong>. Customers must pay for premium images
      through accepted payment methods (e.g., credit cards, PayPal). Payments
      are non-refundable unless otherwise specified in our
      <a routerLink="/refund-policy">Refund Policy</a>.
    </p>
  }
  @if (false) {
    <p><strong>4.2. Subscriptions</strong></p>
    <p>
      Subscriptions grant access to a specified number of downloads per month.
      Additional charges may apply if you exceed your limit.
    </p>
    <p><strong>4.3. Price Changes</strong></p>
  } @else {
    <p><strong>4.2. Price Changes</strong></p>
  }
  @if (false) {
    <p>
      We reserve the right to modify prices at any time. Price changes will not
      affect subscriptions already paid for until the next billing cycle.
    </p>
  } @else {
    <p>We reserve the right to modify prices at any time.</p>
  }
  <p><strong>5. Free Images</strong></p>
  <p><strong>5.1. Usage</strong></p>
  <p>
    Free images are provided under a limited license. You may use them for
    personal projects and limited commercial purposes, provided attribution
    requirements are met (if applicable).
  </p>
  <p><strong>5.2. Restrictions</strong></p>
  <p>
    Free images may not be used for resale, redistribution, or large-scale
    commercial projects without prior approval or licensing.
  </p>
  <p><strong>6. Limitation of Liability</strong></p>
  <p><strong>6.1. Disclaimer of Warranties</strong></p>
  <p>
    The ImageBase.pro platform is provided “as is,” without warranties of any
    kind, either express or implied. We do not guarantee that:
  </p>
  <ul>
    <li>The platform will function without errors or interruptions.</li>
    <li>The content will meet your expectations.</li>
  </ul>
  <p><strong>6.2. Limitation of Liability</strong></p>
  <p>
    Neither <strong>V V G LLC</strong> nor <strong>DIGITAL DP LTD</strong> shall
    be held liable for any indirect, incidental, special, or consequential
    damages arising from the use of the platform or its content.
  </p>
  <p><strong>7. Termination of Use</strong></p>
  <p><strong>7.1. Termination by User</strong></p>
  <p>
    You may terminate your account at any time by contacting our support team.
  </p>
  <p><strong>7.2. Termination by the Platform</strong></p>
  <p>
    We reserve the right to suspend or terminate your access to the platform
    without prior notice if you violate these terms.
  </p>
  <p><strong>8. Privacy</strong></p>
  <p>
    Your use of the platform is also governed by our
    <a routerLink="/privacy-policy">Privacy Policy</a>, which outlines how we
    collect, store, and use your personal information.
  </p>
  <p><strong>9. Governing Law</strong></p>
  <p>
    These terms are governed by and construed in accordance with the laws of the
    jurisdiction where <strong>DIGITAL DP LTD</strong> is registered. All
    disputes shall be resolved exclusively in the courts of this jurisdiction.
  </p>
  <p><strong>10. Contact Information</strong></p>
  <p>
    If you have any questions regarding these Terms of Use, please contact us:
  </p>
  <p>
    <strong>DIGITAL DP LTD</strong><br />
    82a James Carter Road, Mildenhall,<br />
    Bury St. Edmunds, England, IP28 7DE<br />
    <span>Email:</span>
    <a
      [href]="'mailto:' + environment.support_email"
      [textContent]="environment.support_email"
    ></a>
  </p>
  <p>
    Thank you for choosing <strong>ImageBase.pro</strong>. By adhering to these
    terms, we aim to ensure a safe, reliable, and high-quality experience for
    all users.
  </p>
</div>
